<template>
  <FluxoCompletoComponent
    :category="3"
    :title="'Fluxo Completo Uniformes NR10'"
  />
</template>

<script>
import FluxoCompletoComponent from "../components/FluxoCompletoComponent.vue";
export default {
  components: {
    FluxoCompletoComponent,
  },
};
</script>

<style></style>
